module.exports = __webpack_public_path__ + "static/Innovadores-Fianancieros-ena-las-Americas-575551bfb093597983838b07b425ed98.png";